// src/store/selectors/ui/index.ts
import type { RootState } from '@/store';

export const selectUi = (state: RootState) => state.ui;
export const selectConfirm = (state: RootState) => selectUi(state).confirm;
export const selectModal = (state: RootState) => selectUi(state).modal;
export const selectShowLoader = (state: RootState) => selectUi(state).showLoader;
export const selectErrorMessage = (state: RootState) => selectUi(state).errorMessage;
export const selectPollingModal = (state: RootState) => selectUi(state).pollingModal;
